module.exports = "/static/assets/2b7f706af117e45b1f3717e929eba19e.png";